function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M504.504,242.557c-5.639-1.55-10.422,1.92-12.346,7.01c-3.303,8.738-15.727,13.964-24.715,15.136 c-13.537,1.766-26.728-4.162-38.688-9.71c-14.188-6.58-28.811-12.86-44.761-12.726c-16.05,0.135-31.718,6.547-44.789,15.561 c-14.714,10.146-26.534,23.386-38.099,36.861c-3.528,4.111-4.039,10.155,0,14.194c3.612,3.612,10.649,4.131,14.194,0 c18.57-21.64,43.045-50.187,74.963-46.258c15.07,1.855,28.568,10.265,42.4,15.879c14.218,5.771,29.814,8.498,44.883,4.538 c14.937-3.926,28.395-13.401,33.966-28.14C513.431,249.832,509.385,243.898,504.504,242.557z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M206.526,136.556c9.489-13.142,19.603-27.179,22.491-43.507c2.801-15.839-1.296-31.79-10.119-45.126 c-10.176-15.38-24.946-26.448-39.525-37.348c-4.345-3.248-11.214-0.705-13.732,3.6c-2.998,5.126-0.754,10.476,3.601,13.732 c22.432,16.771,50.483,40.105,36.993,71.334c-11.981,27.734-43.153,50.042-39.256,83.306c1.878,16.028,11.389,30.52,27.593,34.802 c12.502,3.303,17.834-16.054,5.337-19.357c-10.125-2.675-14.124-13.736-13.042-23.436 C188.44,160.472,198.459,147.729,206.526,136.556z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M350.593,160.931c-1.628-13.342-9.18-25.426-20.465-32.766c-6.288-4.089-13.129-6.241-20.069-6.792 c3.432-11.313,9.856-21.708,19.247-28.903c4.296-3.291,6.58-8.64,3.601-13.732c-2.473-4.228-9.402-6.918-13.732-3.601 c-16.022,12.276-26.723,29.883-30.557,49.347c-13.101,4.765-24.752,14.388-31.466,26.341 c-18.046,32.125-6.643,69.68,11.514,98.884c6.807,10.948,24.18,0.881,17.333-10.131c-11.843-19.049-21.826-41.886-16.655-64.751 c2.51-11.096,8.876-21.496,17.968-27.655c0.876,11.014,3.97,21.889,9.353,31.545c7.472,13.402,21.656,24.528,37.328,17.034 C346.645,189.702,352.204,174.141,350.593,160.931z M328.252,174.772c-5.463,7.795-11.203-0.705-14.254-6.188 c-4.154-7.465-6.401-15.976-6.802-24.469c-0.041-0.88-0.046-1.766-0.052-2.653c0.495,0.02,0.99,0.042,1.49,0.084 C323.343,142.781,337.622,161.402,328.252,174.772z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M391.394,188.338c-12.916,0-12.938,20.074,0,20.074C404.31,208.411,404.331,188.338,391.394,188.338z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M403.914,159.297c-12.916,0-12.937,20.074,0,20.074C416.83,179.371,416.852,159.297,403.914,159.297z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M423.526,184.907c-12.916,0-12.937,20.074,0,20.074C436.442,204.981,436.463,184.907,423.526,184.907z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M89.658,102.77c-12.916,0-12.938,20.074,0,20.074C102.575,122.844,102.596,102.77,89.658,102.77z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M102.178,73.731c-12.916,0-12.937,20.074,0,20.074C115.095,93.804,115.117,73.731,102.178,73.731z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M121.79,99.34c-12.916,0-12.937,20.074,0,20.074C134.706,119.414,134.727,99.34,121.79,99.34z"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M283.339,354.429L150.051,221.141c-2.282-2.281-5.521-3.328-8.708-2.809c-3.185,0.518-5.928,2.535-7.369,5.423 l-11.984,23.998L1.058,489.96c-1.929,3.863-1.171,8.527,1.883,11.581c1.926,1.927,4.494,2.94,7.099,2.94 c1.522,0,3.056-0.346,4.48-1.058l266.205-132.917c2.888-1.441,4.906-4.183,5.423-7.369 C286.667,359.951,285.621,356.712,283.339,354.429z M32.443,472.037l43.376-86.873l14.645,57.904L32.443,472.037z M198.081,389.334l-17.09-41.651c-2.105-5.128-7.966-7.58-13.095-5.476c-5.128,2.104-7.58,7.967-5.476,13.095l17.653,43.023 l-71.225,35.562l-19.286-76.251l40.518-81.151l11.149,27.172c1.593,3.881,5.339,6.23,9.289,6.23c1.269,0,2.559-0.242,3.806-0.754 c5.128-2.104,7.58-7.967,5.476-13.095l-17.809-43.405l3.718-7.445l113.584,113.584L198.081,389.334z"
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M470.604,333.394c-22.392,0-40.609,18.217-40.609,40.609c0,22.397,18.217,40.619,40.609,40.619 c22.398,0,40.619-18.222,40.619-40.619C511.223,351.611,493.002,333.394,470.604,333.394z M470.604,394.548 c-11.323,0-20.535-9.217-20.535-20.545c0-11.323,9.213-20.535,20.535-20.535c11.328,0,20.545,9.212,20.545,20.535 C491.149,385.331,481.933,394.548,470.604,394.548z"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M459.836,50.827l-40.368-40.368c-1.883-1.882-4.436-2.94-7.098-2.94s-5.214,1.058-7.097,2.941l-40.358,40.368 c-3.918,3.919-3.917,10.274,0.001,14.194l40.358,40.358c1.96,1.96,4.529,2.94,7.097,2.94s5.137-0.98,7.096-2.939l40.368-40.358 c1.884-1.882,2.941-4.435,2.941-7.098C462.775,55.263,461.717,52.71,459.836,50.827z M412.373,84.09l-26.165-26.166l26.165-26.172 l26.172,26.172L412.373,84.09z"
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M160.254,315.887c-12.916,0-12.937,20.074,0,20.074C173.17,335.961,173.191,315.887,160.254,315.887z"
})));

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

export default __webpack_public_path__ + "static/media/confetti.37cec58c.svg";
export { SvgComponent as ReactComponent };